// Module
var code = "<div class=\"error-503\"> <div class=\"error-503__text\"> <h3 class=\"md-headline text-center\" layout-padding> Down for maintenance ... </h3> </div> </div> ";
// Exports
module.exports = code;